import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import { Divider, Grid, units } from '@ha/dsl';

import Imgix from 'ha/components/next/Imgix';
import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import Img from 'ha/ui/next/Img';

const useStyles = makeStyles(theme => ({
  divider: {
    width: '1px',
    margin: units.yx(0.25, 1),
    height: 'calc(100% - 0.5rem)',
  },
  logo: {
    height: 50,
  },
  text: {
    margin: 0,
    lineHeight: 1,
  },
  flex: {
    display: 'flex',
  },
  brand: {
    color: theme.palette.orange.main,
  },
}));

type Props = {
  url: string;
};

const AdvertiserLogo: React.FC<Props> = ({ url }) => {
  const classes = useStyles();
  const { imgix } = useFeatureFlags();
  const { T } = useIntl();

  return (
    <Grid container>
      <Grid item>
        {imgix === 'on' ? (
          <Imgix
            className={classes.logo}
            htmlAttributes={{
              'data-test-locator': 'advertiser-logo',
              alt: 'Advertiser logo',
            }}
            imgixParams={{ fit: 'clip' }}
            sizes="100vw"
            src={url}
          />
        ) : (
          <Img
            src={url}
            className={classes.logo}
            dataTestLocator="advertiser-logo"
            alt="Advertiser logo"
          />
        )}
      </Grid>
      <Divider kind="spaced-m" className={classes.divider} />
      <Grid item className={classes.flex}>
        <Grid container direction="column" justify="center">
          <Grid item className={classes.text}>
            {T('navbar.advertiser_logo.title')}
          </Grid>
          <Grid item className={cx(classes.text, classes.brand)}>
            {T('navbar.advertiser_logo.subtitle')}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdvertiserLogo;
